import React from 'react'
import PropTypes from 'prop-types'

import CheckoutSectionHeader from './CheckoutSectionHeader'
import CheckoutSectionBody from './CheckoutSectionBody'

const CheckoutSection = ({ label, toolTip, children, classname, hidden = false, hideBodyBorder = false }) => (
    <div>
        {label && <CheckoutSectionHeader label={label} toolTip={toolTip} />}
        <div
            className={classname || label && label.toLowerCase().replace(' ', '-') + (hidden ? " d-none " : "")}
            style={{ marginBottom: "2rem" }}
        >
            <CheckoutSectionBody hideBodyBorder={hideBodyBorder}>
                {children}
            </CheckoutSectionBody>
        </div>
    </div>
)

CheckoutSection.propTypes = {
  label: PropTypes.string,
  classname: PropTypes.string,
  hidden: PropTypes.bool,
  hideBodyBorder: PropTypes.bool
}

export default CheckoutSection